import { Center, Loader } from "@mantine/core";
import { safeApiCall } from "api/common.service";
import { getRptSalesPersonByMonth } from "api/report.service";
import React, { useEffect, useState } from "react";
import { RptSalesPersonByMonths } from "types/model.types";

const SalesPersonByMonthPreview: React.FC = () => {
  const [data, setData] = useState<RptSalesPersonByMonths>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        const result = await safeApiCall(getRptSalesPersonByMonth());
        if (mounted && result) {
          setData(result.data ?? []);
        }
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData();

    return () => {
      mounted = false;
    };
  }, []);

  const monthKeys = [
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec",
  ] as const;
  if (loading) {
    return (
      <Center style={{ height: "100vh" }}>
        <Loader size="lg" />
      </Center>
    );
  }
  return (
    <>
      <div className="sub-title">Sales Person By Month</div>
      <table className="details-table">
        <thead>
          <tr>
            <th className="description xs-2">Sales Person</th>
            <th className="description xs-2">Debtor</th>
            {monthKeys.map((month) => (
              <th key={month}>{month.toUpperCase()}</th>
            ))}
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={`${row.salesPerson}-${row.debtorId}`}>
              <td className="description xs-2">{row.salesPerson}</td>
              <td className="description xs-2">{`[${row.debtorId}] ${row.debtor}`}</td>
              {monthKeys.map((month) => (
                <td key={month}>{row[month]}</td>
              ))}
              <td>{row.totalSales}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default SalesPersonByMonthPreview;
